<template>
  <LightBox class="gap-3 box" dense>
    <div v-for="{ icon, text } in POINTS">
      <small class="flex gap-2">
        <AppIcon :icon color="tertiary" />
        {{ text }}
      </small>
    </div>
  </LightBox>
</template>

<script setup lang="ts">
const { tt } = useLocalization();
const POINTS = [
  { icon: 'mdi:shield-check', text: tt('safety_box.secure_payment') },
  { icon: 'mdi:lock', text: tt('safety_box.ssl') },
  { icon: 'mdi:file-document-check-outline', text: tt('safety_box.official_visa') },
  { icon: 'mdi:support', text: tt('safety_box.support') },
  { icon: 'mdi:money', text: tt('safety_box.refund') }
];
</script>

<style scoped>
.box {
  display: flex;
  background-color: #f3f9ff;
  justify-content: space-between;
}

@media (max-width: 850px) {
  .box {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    flex-direction: column;
    width: 100%;
  }
  .box div:last-child {
    grid-column: span 2 / span 2;
  }
}
</style>